module.exports = __webpack_public_path__ + "img/Guirlande_lettre.0ffbef8.jpg";